import classNames from "classnames";
import { type ImgHTMLAttributes, forwardRef } from "react";

export const BaseImage = forwardRef<
  HTMLImageElement,
  ImgHTMLAttributes<HTMLImageElement> & {
    imgProps?: Omit<
      ImgHTMLAttributes<HTMLImageElement>,
      | "src"
      | "alt"
      | "className"
      | "width"
      | "height"
      | "style"
      | "loading"
      | "fetchpriority"
      | "decoding"
      | "ref"
    >;
    disableDownload?: boolean;
  }
>(
  (
    {
      src,
      alt,
      className,
      width,
      height,
      style,
      loading = "eager",
      fetchPriority = "high",
      decoding = "async",
      imgProps,
      disableDownload,
      ...rest
    },
    ref,
  ) => {
    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        onDragStart={disableDownload ? (e) => e.preventDefault() : undefined}
        onContextMenu={disableDownload ? (e) => e.preventDefault() : undefined}
        className={classNames(className, disableDownload && "pointer-events-none")}
        width={width}
        height={height}
        style={style}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding={decoding}
        {...imgProps}
        {...rest}
      />
    );
  },
);

BaseImage.displayName = "BaseImage";
